import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Menu from '@material-ui/core/Menu'

const transformOrigin = { vertical: 'bottom', horizontal: 'right' }
const anchorOrigin = { vertical: 'top', horizontal: 'right' }

class MoreVertMenu extends PureComponent {
  state = {
    anchorEl: undefined,
    open: false
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  }

  handleRequestClose = () => {
    this.setState({ open: false })
  }

  render() {
    return (
      <div className={this.props.className}>
        <IconButton
          aria-label='More'
          aria-owns={this.state.open ? this.props.id : null}
          aria-haspopup='true'
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id={this.props.id}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          transformOrigin={transformOrigin}
          anchorOrigin={anchorOrigin}
        >
          {this.props.children}
        </Menu>
      </div>
    )
  }
}

MoreVertMenu.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
}

export default MoreVertMenu



// WEBPACK FOOTER //
// ./src/routes/MoreVertMenu/MoreVertMenu.js